import { IGeoStep } from '../types';
import { EGeoTypes } from '../constants/geoTypes';
import { EStepField } from '../constants/stepField';
import {
  EDealTypeEx,
  EObjectType,
} from '../../../repositories/demand/entities/public_v2_create_personal_message/CreatePersonalMessageV2RequestSchema';

const REASONS_MAP: Record<EDealTypeEx, string> = {
  buy: 'купить',
  sale: 'продать',
  tenant: 'снять',
  rent: 'сдать',
  sellToBuy: 'продать, чтобы купить',
};
export type TReason = keyof typeof REASONS_MAP;

const OBJECT_TYPE_MAP: Partial<Record<EObjectType, string>> = {
  flat: 'квартиру',
  room: 'комнату',
  house: 'дом или дачу',
  cottage: 'коттедж',
  townhouse: 'таунхаус',
  houseShare: 'часть дома',
  land: 'участок',
  office: 'офис',
  shoppingArea: 'торговую площадь',
  freeAppointmentObject: 'помещение свободного назначения',
  industry: 'производство',
  warehouse: 'склад',
  garage: 'гараж',
  business: 'готовый бизнес',
  commercialLand: 'коммерческую землю',
};

export type TObjectType = keyof typeof OBJECT_TYPE_MAP;

export const getLocationStep = (reason: TReason, objectType: TObjectType, mainQuestion?: string): IGeoStep => {
  const reasonText = REASONS_MAP[reason]; // NOTE: Действие, купить/продать/тд
  const objectText = OBJECT_TYPE_MAP[objectType]; // NOTE: Объект, квартиру/землю/тд
  const mainQuestionText = mainQuestion || 'В каком городе или регионе вы хотите';

  const title =
    reasonText && objectText ? `${mainQuestionText} ${reasonText} ${objectText}?` : 'Укажите город или регион';

  return {
    title,
    isRequired: true,
    field: EStepField.location,
    types: [EGeoTypes.region],
    placeholder: 'Название города или региона',
  };
};
